import { Component, OnInit } from "@angular/core";
import { ClientService } from "../service/client.service";
import { CallsReportDto } from "../model/callsReportDto";

@Component({
  selector: "app-calls-report",
  templateUrl: "./calls-report.component.html",
  styleUrls: ["./calls-report.component.css"],
})
export class CallsReportComponent implements OnInit {
  callsReport: CallsReportDto[] = [];
  filteredCallsReport: CallsReportDto[] = []; // filtered version for table
  isLoading = false;

  // Filters
  fromDate?: Date;
  toDate?: Date;
  statusFilter: string = "all"; // 'all', 'open', 'closed'

  // Filter by CallTypeId
  callTypeFilter: number | "all" = "all";

  orderNumberFilter: string = "";
  callIdFilter: string = "";

  uniqueCallTypes = [];

  cols = [
    { field: "ClientDestinationName", header: "שם יעד" },
    { field: "ClientDestinationNumber", header: "מספר יעד" },
    { field: "CallId", header: "מספר פניה" },
    { field: "OrderNumber", header: "מספר הזמנה" },
    { field: "CallStatus", header: "סטטוס" },
    {
      field: "CallCreatedBy",
      header: "נוצר על ידי",
      width: "150",
    },
    { field: "CallTypeDescription", header: "סוג תקלה" },
    { field: "CallOpenDate", header: "תאריך פתיחה" },
    { field: "CallCloseDate", header: "תאריך סגירה" },
    { field: "CallDetails", header: "פרטים" },
    { field: "SentToUsers", header: "נישלח ל -", width: "150" },
  ];

  constructor(private clientService: ClientService) {}

  ngOnInit() {
    this.getCallsReport();
  }

  getCallsReport = () => {
    this.isLoading = true;
    this.clientService.getCallsReport().subscribe(
      (response) => {
        this.callsReport = response;

        // --- Simple unique CallType logic ---
        this.uniqueCallTypes = [];
        this.callsReport.forEach((r) => {
          if (
            this.uniqueCallTypes.findIndex((t) => t.id === r.CallTypeId) === -1
          ) {
            this.uniqueCallTypes.push({
              id: r.CallTypeId,
              desc: r.CallTypeDescription,
            });
          }
        });
        // -------------------------------------

        this.applyFilters();
        this.isLoading = false;
      },
      (error) => {
        console.log(error);
        this.isLoading = false;
      },
    );
  };

  applyFilters() {
    this.filteredCallsReport = this.callsReport.filter((row) => {
      // Status filter
      if (this.statusFilter === "open" && row.CallStatus !== 1) return false;
      if (this.statusFilter === "closed" && row.CallStatus !== 0) return false;

      // Call Type filter
      if (
        this.callTypeFilter !== "all" &&
        row.CallTypeId !== this.callTypeFilter
      )
        return false;

      // Date filter (CallOpenDate)
      if (this.fromDate) {
        const from = new Date(this.fromDate);
        const openDate = new Date(row.CallOpenDate);
        if (openDate < from) return false;
      }
      if (this.toDate) {
        const to = new Date(this.toDate);
        to.setHours(23, 59, 59, 999);
        const openDate = new Date(row.CallOpenDate);
        if (openDate > to) return false;
      }

      // Order Number filter
      if (this.orderNumberFilter) {
        if (!row.OrderNumber) return false;
        if (!row.OrderNumber.toString().includes(this.orderNumberFilter))
          return false;
      }

      // CallId filter
      if (this.callIdFilter) {
        if (!row.CallId) return false;
        if (!row.CallId.toString().includes(this.callIdFilter)) return false;
      }

      return true;
    });
  }

  getCallStatusText(status: number): string {
    return status === 1 ? "פתוחה" : "סגורה";
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/calls-report/calls-report.component.ts